var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.364 1.134a.564.564 0 0 0-.728 0L.448 6.384a.564.564 0 0 0-.066.792c.2.237.556.265.793.066l.576-.488v4.371c0 1.036.84 1.875 1.875 1.875h6.75a1.874 1.874 0 0 0 1.875-1.875v-4.37l.574.487a.561.561 0 1 0 .727-.858zm-4.488 9.991V5.8l4.125-3.499 4.125 3.5v5.324a.75.75 0 0 1-.75.75H9.251V8.313a.937.937 0 0 0-.937-.938H5.689a.937.937 0 0 0-.938.938v3.562H3.626a.75.75 0 0 1-.75-.75m3 .75V8.5h2.25v3.375z"
  })));
};
export default SvgHome;